class blogService {
  /**
   * Get paginated blogs. Response: { data: [], total, page, limit, totalPages }.
   * @param {string} [query] - e.g. "page=1&limit=10" or "page=1&limit=10&status=published&sort=createdAt&order=desc&category=...&search=..."
   */
  async getAllBlogs(query = "") {
    const baseUrl = useRuntimeConfig().public.API_URL + "/getAllBlogs";
    const url = query ? `${baseUrl}?${query}` : baseUrl;
    const response = await $fetch(url, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
    return response;
  }

  /**
   * Get blog by titleUrl+category or by id. Use ?id=<_id> or ?_id=<_id> for edit.
   */
  async getBlogDetail(query) {
    const response = await $fetch(
      useRuntimeConfig().public.API_URL + "/getBlogDetails?" + query,
      { headers: { "Content-Type": "application/json" }, method: "GET" }
    );
    return response;
  }

  async getActiveCategories(query = "") {
    const baseUrl = useRuntimeConfig().public.API_URL + "/getAllCategories";
    const url = query ? `${baseUrl}?${query}` : baseUrl;
    const response = await $fetch(url, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
    return response;
  }
}

export default new blogService();
  
  
  
  
  
  
  
  
  
  
